import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@core/store/store'

const isLoading = (state: RootState) => state.loadingReducer
export const loadingSelector = createSelector(
  isLoading,
  loadingReducer => loadingReducer.isLoading,
)
